import Vue from 'vue';

Vue.component('brandstore-details-component', {
    data() {
        return {
            selectedBrandStore: null,
        };
    },

    mounted() {
        EventBus.$on('brandstore-selected', (brandstoreValue) => {
            this.selectedBrandStore = brandstoreValue;
        });

        EventBus.$on('brandstore-cleared', () => {
            this.selectedBrandStore = null;
        });
    },

    beforeDestroy() {
        EventBus.$off('brandstore-selected', (brandstoreValue) => {
            this.selectedBrandStore = brandstoreValue;
        });

        EventBus.$off('brandstore-cleared', () => {
            this.selectedBrandStore = null;
        });
    },
});
